import { __decorate } from "tslib";
import { createDialogInstance } from '@/infrastructure/decorators/dialog';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { create } from '@patsnap/tahiti-core/utils/deferred';
let ConfirmServiceImpl = class ConfirmServiceImpl {
    get instance() {
        if (!this._instance) {
            this._instance = createDialogInstance(() => import('@/presentation/components/ConfirmDialog.vue'));
        }
        return this._instance;
    }
    confirm(options) {
        this._deferred = create();
        this.instance.onReceived((data, next) => {
            this._deferred.resolve(true);
            next();
        });
        this.instance.onAborted(() => {
            this._deferred.resolve(false);
        });
        this.instance.request(options);
        return this._deferred.promise;
    }
};
ConfirmServiceImpl = __decorate([
    injectable()
], ConfirmServiceImpl);
export { ConfirmServiceImpl };
